<template>
  <div>
    <p class="pb-3 text-sm">{{ title }}</p>
    <div class="flex items-center space-x-4 gap-8 text-sm">
      <label v-for="(option, index) in options" :key="index" class="flex items-center space-x-2">
        <input
          type="radio"
          :name="name"
          :id="name + '-' + option.value"
          :value="option.value"
          v-model="value"
          class="form-radio text-blue"
        />
        <span>{{ option.label }}</span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    initialValue: {
      required: false,
      default: "",
    },
    options: {
      type: Array,
      required: true,
    },
    handleChange: {
      type: Function,
    }
  },

  data() {
    return {
      value: this.initialValue,
      errors: this.initialErrors,
    };
  },
  watch: {
    value: function (value) {
      const name = this.name;
      this.$emit("handle-change", { value, name });
    },
  },
};
</script>

<style lang="scss" scoped>
::-webkit-calendar-picker-indicator {
  filter: invert(1);
  opacity: 0.5;
}
.field-wrapper {
  position: relative;
  height: 48px;
  cursor: text;
  &:hover {
    border: 1px solid white;
    &.hasErrors {
      border: 1px solid #cc0000;
    }
  }
}

.field-wrapper input {
  /* border: 1px solid #656662; */
  border: 1px solid #bfbfbf;
  padding: 15px;
  border-radius: 4px;
  width: 100%;
  height: 100%;
  background-color: transparent;
  color: white;
}

.field-wrapper input:focus {
  border: 1px solid white;
}

.field-wrapper.hasErrors input {
  border: 1px solid #cc0000;
}

.field-wrapper .field-placeholder {
  font-size: 16px;
  position: absolute;
  bottom: 10px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #80868b;
  left: 8px;
  padding: 0 8px;
  -webkit-transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1),
    opacity 150ms cubic-bezier(0.4, 0, 0.2, 1);
  transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1),
    opacity 150ms cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1;
  text-align: left;
  width: 100%;
}

.field-wrapper .field-placeholder span {
  background: #0f304d;
  padding: 0px 8px;
  color: #999;
  font-weight: normal;
}

.field-wrapper input:not([disabled]):focus ~ .field-placeholder {
  color: white;
  span {
    color: white;
  }
}

.field-wrapper input:not([disabled]):focus ~ .field-placeholder,
.field-wrapper.hasValue input:not([disabled]) ~ .field-placeholder {
  -webkit-transform: scale(0.75) translateY(-33px) translateX(-16%);
  transform: scale(0.75) translateY(-33px) translateX(-16%);
}
</style>
